<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col">
        <div class="row pb-3">
          <div class="col"><h5>Projects</h5></div>
        </div>

        <div class="card" v-if="!user.email_verified">
        <div class="card-body">
<p class="text-center mb-0">Please <a href="/verify-email" class="highlight">verify your email</a></p>
        </div>
        </div>

      <div class="card" v-else-if="!user.seller_complete">
        <div class="card-body">
<p class="text-center mb-0">Please complete your <a href="/profile/edit" class="highlight">profile</a> and banking details</p>
        </div>
        </div>

        <div class="card" v-else-if="!user.seller_banking">
        <div class="card-body">
<p class="text-center mb-0">Please enter your <a href="/profile/edit-banking" class="highlight">banking details</a></p>
        </div>
        </div>

       <b-card no-body v-else>
      <b-tabs v-model="tabIndex" card align="center">
        <b-tab title="Available" title-link-class="darklink">
          <b-card-text>
            <seller-projects-list :status="0"></seller-projects-list>
            </b-card-text>
        </b-tab>
        <b-tab title="Quote sent" title-link-class="darklink">
          <b-card-text>
            <seller-projects-list :status="1"></seller-projects-list></b-card-text>
        </b-tab>
        <b-tab title="In progress" title-link-class="darklink">
          <b-card-text>
            <seller-projects-list :status="2"></seller-projects-list></b-card-text>
        </b-tab>
        <b-tab title="Waiting for review" title-link-class="darklink">
          <b-card-text>
            <seller-projects-list :status="3"></seller-projects-list></b-card-text>
        </b-tab>
        <b-tab title="Completed" title-link-class="darklink">
          <b-card-text>
            <seller-projects-list :status="4"></seller-projects-list></b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>

      </div>
    </div>
  </div>
</template> 

<script>
export default {
  props: ['user'],

  data() {
    return {
      tabIndex: 0,
      creating: false,
    };
  },

  created() {},

  methods: {

  },

};
</script>

<style scoped>
td:hover {
  cursor: pointer;
}
.application_image {
  width: 100%;
  border-radius: 0.25rem;
}
</style>